const COUNTRY = { VN: 'VN' };

export { COUNTRY };
